import React from 'react';
import FeatureDocumentation from '../../components/layouts/docsection';
import ProfitProcess from "../../images/profitProcessing.png";

const ProfitProcessing = () => {
  const ProfitProcessingDocs = {
    title: "Profit Processing",
    description: "This documentation provides insights into the process of profit calculation and management. It details how profits are processed, tracked, and made available for payouts.",
    image: ProfitProcess,
    imageAlt: "Profit Processing Interface",
    imageCaption: "Figure 1: Comprehensive view of the profit processing workflow and status.",
    sections: [
      {
        title: "Overview",
        content:
          "The profit processing system is designed to manage and track the profits generated from sales effectively. Once an order is successfully completed, it typically takes four days for the reseller to become eligible for a payout. During this period, the system prepares the necessary calculations and updates the status of the profits accordingly. If the payout is not ready due to any discrepancies or issues, the system provides a 'retry' option to refresh the status and reprocess the profit calculations. This ensures that all transactions are accurately reflected, and resellers are compensated promptly for their sales activities."
      },
    ],
  };
  
  return <FeatureDocumentation{...ProfitProcessingDocs}/>
};

export default ProfitProcessing;
